// @see https://github.com/AS3Commons/as3commons-lang/blob/master/src/main/actionscript/org/as3commons/lang/DictionaryUtils.as

import { CREATEJS_UTILITIES_LOGGER } from "../../../index";
import { getLogger } from "@goodgamestudios/logger";
const logger = getLogger(CREATEJS_UTILITIES_LOGGER);

export class DictionaryUtils {

    public static getKeys(dictionary:any) : string[] {
        //return ObjectUtils.getKeys(dictionary);
        const message = "DictionaryUtils.getKeys is not yet implemented";
        logger.debug(message);
        return message.split(' ');
    }
}